/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForSecurityRecommendationAws extends models.GovernanceConfigurationBaseForSecurityRecommendation {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForSecurityRecommendationAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForSecurityRecommendationAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForSecurityRecommendationAws>): GovernanceConfigurationForSecurityRecommendationAws {
        let obj = Object.assign(new GovernanceConfigurationForSecurityRecommendationAws(), model);
        GovernanceConfigurationForSecurityRecommendationAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForSecurityRecommendationAws>): GovernanceConfigurationForSecurityRecommendationAws {
        if (!model) return null;
        return GovernanceConfigurationForSecurityRecommendationAws.newInstance(<GovernanceConfigurationForSecurityRecommendationAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForSecurityRecommendationAws) {
        if (!obj) return;

        models.GovernanceConfigurationForSecurityRecommendationAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForSecurityRecommendationAws): boolean {
        if (models.GovernanceConfigurationBaseForSecurityRecommendation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForSecurityRecommendationAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether Security Hub enabled or not
     */
    security_hub_enabled: boolean;

}
